module.exports = __webpack_public_path__ + "img/logo_lemodi_03.7eddc570.svg";